export const PlusIcon = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.0469 11.1406H13.4844V4.57812C13.4844 4.41406 13.3203 4.25 13.1562 4.25H11.8438C11.6387 4.25 11.5156 4.41406 11.5156 4.57812V11.1406H4.95312C4.74805 11.1406 4.625 11.3047 4.625 11.4688V12.7812C4.625 12.9863 4.74805 13.1094 4.95312 13.1094H11.5156V19.6719C11.5156 19.877 11.6387 20 11.8438 20H13.1562C13.3203 20 13.4844 19.877 13.4844 19.6719V13.1094H20.0469C20.2109 13.1094 20.375 12.9863 20.375 12.7812V11.4688C20.375 11.3047 20.2109 11.1406 20.0469 11.1406Z"
      fill="#292B29"
    />
  </svg>
);
